/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IInternalProjectsInputScheduledTasksUpdate,
  IInternalProjectsInputCreate,
  IInternalProjectsInputGeneralSettings,
  IInternalProjectsInputManageCustomFilter,
  IInternalProjectsInputCreateDescriptionTemplate,
  IInternalProjectsInputUpdateCustomFilter,
  IInternalProjectsInputUpdateDescriptionTemplate,
  IInternalProjectsInputChangeWorkflow,
  IInternalProjectsInputIncomingEmailSettings,
  IInternalProjectsInputChecklistTemplateCreate,
  IInternalProjectsInputChecklistTemplateUpdate,
  IInternalProjectsInputCustomFieldCreate,
  IInternalProjectsInputCustomFieldUpdate,
  IInternalProjectsInputScheduledTasksCreate,
  IWorkflowStatusPropertiesUpdate,
} from '../types/request.types'
import {
  IScheduledTask,
  IGenericJSONMessage,
  IItemForSelection,
  IProjectsOutputNote,
  ILastUpdatedEpochTime,
  IProjectWithWorkflow,
  IProjectsOutputAssignPeople,
  IPersonWithEmail,
  IProjectsOutputMyNotifications,
  IPriorityLevelForSelection,
  IStatusForSelection,
  IPersonBase,
  IInternalProjectsOutputUpdatableInternalProjects,
  IProjectsOutputIntegrations,
  IProjectsOutputProjectForHome,
  IProjectDailyActivityLogs,
  ILimitCheck,
  IProjectForSelection,
  IWorkflowForSelection,
  IInternalProjectsOutputDetail,
  IWorkflowDetailStatusTransition,
  IInternalProjectsOutputDescriptionTemplates,
  IInternalProjectsOutputIncomingEmailSettings,
  IInternalProjectsOutputGeneralSettings,
  IInternalProjectsOutputFilterOptionsForListing,
  IInternalProjectsOutputDefaultFilterOptionCounts,
  IProjectsOutputShowInfoPanelOnLanding,
  IPostSuccess,
  IChecklistTemplate,
  ICustomField,
  IChecklist,
  ICalendarMonth,
  IScheduledTaskOccurrencePage,
  IWorkflowStatusProperty,
} from '../types/response.types'

export default new class InternalProjectsAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_ProjectWorkflowStatusPropertiesGet(
    internal_project_id: any,
  ): Promise<IWorkflowStatusProperty[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/workflow-status-properties`,
    })
  }
  public async get_Title(
    internal_project_id: any,
  ): Promise<IItemForSelection> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/title`,
    })
  }
  public async get_Note(
    internal_project_id: any,
  ): Promise<IProjectsOutputNote> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/note`,
    })
  }
  public async get_MostRecentLastUpdatedEpochTime(
  ): Promise<ILastUpdatedEpochTime> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/most-recent-last-updated-epoch-time`,
    })
  }
  public async get_LastUpdatedEpochTime(
    internal_project_id: any,
  ): Promise<ILastUpdatedEpochTime> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/last-updated-epoch-time`,
    })
  }
  public async get_WithWorkflow(
    internal_project_id: any,
  ): Promise<IProjectWithWorkflow> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/with-workflow`,
    })
  }
  public async get_AssignPeople(
    internal_project_id: any,
  ): Promise<IProjectsOutputAssignPeople> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/assign-people`,
    })
  }
  public async get_AssignGuests(
    internal_project_id: any,
  ): Promise<IProjectsOutputAssignPeople> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/assign-guests`,
    })
  }
  public async get_Members(
    internal_project_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/members`,
    })
  }
  public async get_MembershipCandidates(
    internal_project_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/membership-candidates`,
    })
  }
  public async get_MyNotifications(
    internal_project_id: any,
  ): Promise<IProjectsOutputMyNotifications> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/my-notifications`,
    })
  }
  public async get_Assignees(
    internal_project_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/assignees`,
    })
  }
  public async get_Priorities(
    internal_project_id: any,
  ): Promise<IPriorityLevelForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/priorities`,
    })
  }
  public async get_Statuses(
    internal_project_id: any,
  ): Promise<IStatusForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/statuses`,
    })
  }
  public async get_Creators(
    internal_project_id: any,
  ): Promise<IPersonBase[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/creators`,
    })
  }
  public async get_Tags(
    internal_project_id: any,
  ): Promise<IItemForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tags`,
    })
  }
  public async get_UpdatableInternalProjects(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputUpdatableInternalProjects> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/updatable-internal-projects`,
    })
  }
  public async get_Integrations(
    internal_project_id: any,
  ): Promise<IProjectsOutputIntegrations> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations`,
    })
  }
  public async get_Index(
  ): Promise<IProjectsOutputProjectForHome[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects`,
    })
  }
  public async get_DailyActivityLogs(
  ): Promise<IProjectDailyActivityLogs> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/daily-activity-logs`,
    })
  }
  public async get_LimitCheck(
  ): Promise<ILimitCheck> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/limit-check`,
    })
  }
  public async get_ForSelection(
  ): Promise<IProjectForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/for-selection`,
    })
  }
  public async get_Workflows(
  ): Promise<IWorkflowForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/workflows`,
    })
  }
  public async get_Detail(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputDetail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}`,
    })
  }
  public async get_WorkflowStatusTransitions(
    internal_project_id: any,
  ): Promise<IWorkflowDetailStatusTransition[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/workflow-status-transitions`,
    })
  }
  public async get_DescriptionTemplates(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputDescriptionTemplates> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/description-templates`,
    })
  }
  public async get_GeneralSettings(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputGeneralSettings> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/general-settings`,
    })
  }
  public async get_FilterOptionsForListing(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputFilterOptionsForListing> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/filter-options/listing`,
    })
  }
  public async get_DefaultFilterOptionCounts(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputDefaultFilterOptionCounts> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/default-filter-option-counts`,
    })
  }
  public async get_ShowInfoPanelOnLanding(
    internal_project_id: any,
  ): Promise<IProjectsOutputShowInfoPanelOnLanding> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/show-info-panel-on-landing`,
    })
  }
  public async get_ChecklistTemplates(
    internal_project_id: any,
  ): Promise<IChecklistTemplate[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/checklist-templates`,
    })
  }
  public async get_CustomFields(
    internal_project_id: any,
  ): Promise<ICustomField[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/custom-fields`,
    })
  }
  public async get_ScheduledTasksGetForMonth(
    internal_project_id: any,
    year: any,
    month: any,
  ): Promise<ICalendarMonth> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/scheduled-tasks/for-month/${year}/${month}`,
    })
  }
  public async get_ScheduledTasksGetOccurrences(
    internal_project_id: any,
    date: string,
    page: number,
  ): Promise<IScheduledTaskOccurrencePage> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/scheduled-tasks/occurrences`,
      params: {
        date,
        page,
      },
    })
  }
  public async get_ScheduledTasksGet(
    internal_project_id: any,
    scheduled_task_id: any,
  ): Promise<IScheduledTask> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/scheduled-tasks/${scheduled_task_id}`,
    })
  }
  public async get_IncomingEmailSettings(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputIncomingEmailSettings> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/incoming-email-settings`,
    })
  }
  public async get_EmailAliasGet(
    internal_project_id: any,
  ): Promise<IItemForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/email-aliases`,
    })
  }
  /****** POST methods *****/
  public async post_ScheduledTasksRun(
    internal_project_id: any,
    event_date: string,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/scheduled-tasks/run`,
      data: {
        event_date
      },
    })
  }
  public async post_Archive(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/archive`,
    })
  }
  public async post_Delete(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/delete`,
    })
  }
  public async post_Restore(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/restore`,
    })
  }
  public async post_Favorite(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/favorite`,
    })
  }
  public async post_Unfavorite(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/unfavorite`,
    })
  }
  public async post_AssignPeople(
    internal_project_id: any,
    listPeopleIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/assign-people`,
      data: {
        listPeopleIDs
      },
    })
  }
  public async post_AssignGuests(
    internal_project_id: any,
    listPeopleIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/assign-guests`,
      data: {
        listPeopleIDs
      },
    })
  }
  public async post_MyNotifications(
    internal_project_id: any,
    notificationOptionID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/my-notifications`,
      data: {
        notificationOptionID
      },
    })
  }
  public async post_SetSlackIntegration(
    internal_project_id: any,
    channelID: string,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations/slack`,
      data: {
        channelID
      },
    })
  }
  public async post_RemoveSlackIntegration(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations/slack/remove`,
    })
  }
  public async post_SetGlipIntegration(
    internal_project_id: any,
    apiToken: string,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations/glip`,
      data: {
        apiToken
      },
    })
  }
  public async post_RemoveGlipIntegration(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations/glip/remove`,
    })
  }
  public async post_SetHarvestEnabled(
    internal_project_id: any,
    enabled: boolean,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations/harvest`,
      data: {
        enabled
      },
    })
  }
  public async post_Create(
    data: IInternalProjectsInputCreate,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects`,
      data,
    })
  }
  public async post_GeneralSettings(
    internal_project_id: any,
    data: IInternalProjectsInputGeneralSettings,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/general-settings`,
      data,
    })
  }
  public async post_CreateCustomFilter(
    internal_project_id: any,
    data: IInternalProjectsInputManageCustomFilter,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/custom-filters`,
      data,
    })
  }
  public async post_CreateDescriptionTemplate(
    internal_project_id: any,
    data: IInternalProjectsInputCreateDescriptionTemplate,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/description-templates`,
      data,
    })
  }
  public async post_ChecklistTemplateCreate(
    internal_project_id: any,
    data: IInternalProjectsInputChecklistTemplateCreate,
  ): Promise<IChecklistTemplate> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/checklist-templates`,
      data,
    })
  }
  public async post_ChecklistTemplateAddToTask(
    internal_project_id: any,
    checklist_template_id: any,
    task_id: any,
  ): Promise<IChecklist> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/checklist-templates/${checklist_template_id}/add-to-task/${task_id}`,
    })
  }
  public async post_CustomFieldCreate(
    internal_project_id: any,
    data: IInternalProjectsInputCustomFieldCreate,
  ): Promise<ICustomField> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/custom-fields`,
      data,
    })
  }
  public async post_ScheduledTasksCreate(
    internal_project_id: any,
    data: IInternalProjectsInputScheduledTasksCreate,
  ): Promise<IScheduledTask> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/scheduled-tasks`,
      data,
    })
  }
  public async post_IncomingEmailSettings(
    internal_project_id: any,
    data: IInternalProjectsInputIncomingEmailSettings,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/incoming-email-settings`,
      data,
    })
  }
  public async post_EmailAliasCreate(
    internal_project_id: any,
  ): Promise<IItemForSelection> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/email-aliases`,
    })
  }
  /****** PUT methods *****/
  public async put_ProjectWorkflowStatusPropertiesUpdate(
    internal_project_id: any,
    status_id: any,
    data: IWorkflowStatusPropertiesUpdate,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/workflow-status-properties/${status_id}`,
      data,
    })
  }
  public async put_ScheduledTasksUpdate(
    internal_project_id: any,
    scheduled_task_id: any,
    data: IInternalProjectsInputScheduledTasksUpdate,
  ): Promise<IScheduledTask> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/scheduled-tasks/${scheduled_task_id}`,
      data,
    })
  }
  public async put_RequestAccess(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/request-access`,
    })
  }
  public async put_Title(
    internal_project_id: any,
    name: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/title`,
      data: {
        name
      },
    })
  }
  public async put_UpdateCustomFilter(
    internal_project_id: any,
    custom_filter_id: any,
    data: IInternalProjectsInputUpdateCustomFilter,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/custom-filters/${custom_filter_id}`,
      data,
    })
  }
  public async put_UpdateDescriptionTemplate(
    internal_project_id: any,
    description_template_id: any,
    data: IInternalProjectsInputUpdateDescriptionTemplate,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/description-templates/${description_template_id}`,
      data,
    })
  }
  public async put_AddPeople(
    internal_project_id: any,
    listPeopleIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/people`,
      data: {
        listPeopleIDs
      },
    })
  }
  public async put_ChangeWorkflow(
    internal_project_id: any,
    data: IInternalProjectsInputChangeWorkflow,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/change-workflow`,
      data,
    })
  }
  public async put_Note(
    internal_project_id: any,
    description: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/note`,
      data: {
        description
      },
    })
  }
  public async put_ToggleJobs(
    internal_project_id: any,
    enabled: boolean,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/toggle-jobs`,
      data: {
        enabled
      },
    })
  }
  public async put_ChecklistTemplateUpdate(
    internal_project_id: any,
    checklist_template_id: any,
    data: IInternalProjectsInputChecklistTemplateUpdate,
  ): Promise<IChecklistTemplate> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/checklist-templates/${checklist_template_id}`,
      data,
    })
  }
  public async put_CustomFieldUpdate(
    internal_project_id: any,
    custom_field_id: any,
    data: IInternalProjectsInputCustomFieldUpdate,
  ): Promise<ICustomField> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/custom-fields/${custom_field_id}`,
      data,
    })
  }
  public async put_CustomFieldsUpdateSort(
    internal_project_id: any,
    sorted_custom_field_ids: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/custom-fields/sort`,
      data: {
        sorted_custom_field_ids
      },
    })
  }
  /****** DELETE methods *****/
  public async delete_ScheduledTasksDelete(
    internal_project_id: any,
    scheduled_task_id: any,
    occurrence_date?: string,
    scope?: string,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/scheduled-tasks/${scheduled_task_id}`,
      params: {
        occurrence_date,
        scope,
      },
    })
  }
  public async delete_DeleteDescriptionTemplate(
    internal_project_id: any,
    description_template_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/description-templates/${description_template_id}`,
    })
  }
  public async delete_ChecklistTemplateDelete(
    internal_project_id: any,
    checklist_template_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/checklist-templates/${checklist_template_id}`,
    })
  }
  public async delete_CustomFieldDelete(
    internal_project_id: any,
    custom_field_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/custom-fields/${custom_field_id}`,
    })
  }
  public async delete_EmailAliasDelete(
    internal_project_id: any,
    email_alias_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/email-aliases/${email_alias_id}`,
    })
  }
}()
